import { type CommonErrorResponses as LinkCommonErrorResponses } from '../links/CommonErrorResponses';
import { type MarkMessagesAsReadRequest as SchemaMarkMessagesAsReadRequest } from '../schemas/MarkMessagesAsReadRequest';

/**
 * ‼️ Файл сформирован автоматически. Не редактировать вручную.
 *
 * @tags Messages
 */
export const MarkMessagesAsReadContentType = 'application/json' as const;
export type MarkMessagesAsReadRequest = SchemaMarkMessagesAsReadRequest;
export type MarkMessagesAsReadResponses = LinkCommonErrorResponses & {
    /**
     * @description Messages marked as read successfully
     */
    '200': {};
};
export type MarkMessagesAsReadResponseSuccess = undefined;
export type MarkMessagesAsReadSearchParams = undefined;
export type MarkMessagesAsReadPathParameters = undefined;
export const MarkMessagesAsReadUrl = '/messages/mark_read' as const;
export const MarkMessagesAsReadMethod = 'POST' as const;
export const getMarkMessagesAsReadUrl = (_params?: MarkMessagesAsReadPathParameters) => MarkMessagesAsReadUrl;
